module.exports = __webpack_public_path__ + "img/French.77ff83c9.svg";